webpackJsonp([195351340454287],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  return _react2.default.createElement(
	    'div',
	    { className: 'post' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      post.frontmatter.title
	    ),
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.html } })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-js-46c12254d6f819a7994b.js